import type { LocationQueryRaw, LocationQueryValue, Router } from "vue-router"

export enum Route {
	Activity = "activity",
	ContactResearch = "contact-research",
	Home = "home",
	Hunting = "hunting",
	Login = "login",
	More = "more",
}

export type SelectionQueryParamKey = "opp" | "parcel" | "transaction"
export const SelectionQueryParamKeys: SelectionQueryParamKey[] = ["transaction", "parcel", "opp"]

export function firstQueryValue(value: LocationQueryValue | LocationQueryValue[] | undefined): string | undefined {
	const rawValue = Array.isArray(value) ? value[0] : value
	return rawValue == null ? undefined : rawValue
}

export function replaceSelectionQueryParam(
	router: Router,
	key: SelectionQueryParamKey,
	value: string | null | undefined
): void {
	const nextValue = value ?? undefined
	const query: LocationQueryRaw = { ...router.currentRoute.value.query }

	for (const queryKey of SelectionQueryParamKeys) {
		if (nextValue !== undefined && queryKey !== key) {
			query[queryKey] = undefined
		}
	}

	query[key] = nextValue

	const currentValue = firstQueryValue(router.currentRoute.value.query[key])
	const hasSiblingQueryParam =
		nextValue !== undefined &&
		SelectionQueryParamKeys.some(
			queryKey => queryKey !== key && firstQueryValue(router.currentRoute.value.query[queryKey]) !== undefined
		)

	if (currentValue === nextValue && !hasSiblingQueryParam) return

	void router.replace({ query })
}
